// services/oneTagTracker.js
import Vue from 'vue';
import store from '@/store';
import { GTM_EVENT_NAME_ONE_TAG, GTM_EVENT_VALUES_ONE_TAG } from './constants'; // adjust path

class OneTagTracker {
  // If you wat, you can accept "to" here to also use the route
  trackCalculatorPage(to) {
    if (!to.path.startsWith('/calculator')) {
      return;
    }

    const isThankYou = to.path === '/calculator/thank-you';
    const shortListed = store.getters['shortList/getShortList'] || [];

    let aggregated = {};

    // Only build vehicle details on thank-you page
    if (isThankYou && shortListed?.length) {
      aggregated = {
        make: shortListed
          .map((v) => v.vehicleMake)
          .filter(Boolean)
          .join(', '),
        fuel: shortListed
          .map((v) => v.vehicleFueltype)
          .filter(Boolean)
          .join(', '),
        type: shortListed
          .map((v) => v.vehicleBodytype)
          .filter(Boolean)
          .join(', '),
        variant: shortListed
          .map((v) => v.variant)
          .filter(Boolean)
          .join(', '),
        purchase_price: shortListed
          .map((v) => v.consumerPrice)
          .filter(Boolean)
          .join(', '),
        vehicleCategory: shortListed
          .map((v) => v.vehicleCategory)
          .filter(Boolean)
          .join(', '),
        vehicleDrivetrain: shortListed
          .map((v) => v.vehicleDrivetrain)
          .filter(Boolean)
          .join(', '),
        vehicleModel: shortListed
          .map((v) => v.vehicleModel)
          .filter(Boolean)
          .join(', ')
      };
    }

    setTimeout(() => {
      if (!Vue.gtm) {
        // eslint-disable-next-line no-console
        console.warn('Vue.gtm is not available');
        return;
      }

      const payload = {
        event: GTM_EVENT_NAME_ONE_TAG,
        data: {
          ...GTM_EVENT_VALUES_ONE_TAG,
          ...(aggregated.make && { make: aggregated.make }),
          ...(aggregated.fuel && { fuel: aggregated.fuel }),
          ...(aggregated.type && { type: aggregated.type }),
          ...(aggregated.variant && { variant: aggregated.variant }),
          ...(aggregated.purchase_price && { purchase_price: aggregated.purchase_price }),
          ...(aggregated.vehicleCategory && { vehicleCategory: aggregated.vehicleCategory }),
          ...(aggregated.vehicleDrivetrain && { vehicleDrivetrain: aggregated.vehicleDrivetrain }),
          ...(aggregated.vehicleModel && { vehicleModel: aggregated.vehicleModel })
        }
      };

      Vue.gtm.trackEvent(payload);
    });
  }
}

// export a singleton instance (simple)
export const oneTagTracker = new OneTagTracker();
